const state = {
  unreadCount: 0,
  notifications: [],
  loading: false,
}

const mutations = {
  set_unread_count(state, n) {
    state.unreadCount = Number(n) || 0
  },
  set_notifications(state, items) {
    // normalize read_at / actioned_at so vue 2 installs reactive getter+setters
    // on these keys at observe-time. the API omits them on unread rows (dynamo
    // SET read_at = if_not_exists(...) only adds the attr when marking read),
    // and vue 2 can't observe later-added properties — direct assignments like
    // `n.read_at = now` in our local mutations would silently skip reactivity
    // and components reading `!n.read_at` (notably service_alert_banner.vue)
    // wouldn't update until the next poll. seeding null here fixes that.
    const list = Array.isArray(items) ? items : []
    // drop rows with no displayable content. an empty title + empty
    // body_preview indicates a malformed/orphaned row (early-seeded
    // test data, mistyped TYPE_EMAIL_PREFERENCE near-misses, etc) and
    // would otherwise render as a card with just a generic-bell puck
    // and no body. filtering here covers both the navbar dropdown and
    // the /notifications page in one place.
    const hasContent = (n) => !!(n && ((n.title && String(n.title).trim()) || (n.body_preview && String(n.body_preview).trim())))
    state.notifications = list.filter(hasContent).map(n => ({
      ...n,
      read_at: n && n.read_at ? n.read_at : null,
      actioned_at: n && n.actioned_at ? n.actioned_at : null,
    }))
    state.unreadCount = state.notifications.filter(n => !n.read_at).length
  },
  set_loading(state, value) {
    state.loading = !!value
  },
  mark_read_local(state, ids) {
    const set = new Set(Array.isArray(ids) ? ids : [ids])
    const now = new Date().toISOString()
    state.notifications.forEach(n => {
      if (set.has(n.notification_id) && !n.read_at) n.read_at = now
    })
    state.unreadCount = state.notifications.filter(n => !n.read_at).length
  },
  mark_all_read_local(state) {
    const now = new Date().toISOString()
    state.notifications.forEach(n => { if (!n.read_at) n.read_at = now })
    state.unreadCount = 0
  },
  apply_action_local(state, id) {
    const found = state.notifications.find(n => n.notification_id === id)
    if (found) {
      const now = new Date().toISOString()
      if (!found.read_at) found.read_at = now
      found.actioned_at = now
    }
    state.unreadCount = state.notifications.filter(n => !n.read_at).length
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}
